import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { DesignCard } from "../shared/DesignCard";
import { SectionHeader } from "../shared/SectionHeader";
import { Reveal } from "../shared/Reveal";
import { buttonClass } from "../shared/Button";
import { designs } from "../../data/designs";

// [Journey] [Lead Gen] Four genuine designs → balanced 2×2 grid. Framed for rightsizers: single-level living.
export function DesignDiscovery() {
  return <section id="designs" aria-labelledby="designs-heading" className="bg-paper-deep/60 py-20 md:py-28" data-id="element-208" data-mp="1v8lup4nqki42">
      <div className="mx-auto max-w-site px-5 md:px-10" data-id="element-209" data-mp="1gjzgj69uhwef">
        <SectionHeader id="designs-heading" title="Single-level homes for your next chapter." intro="Four single-storey designs for 10m and 15m frontage categories. Easy living now and for the years ahead, and every design can be tailored to suit you." data-id="element-210" data-mp="1gh3fh92parlr" />

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-211" data-mp="2e0ogsvj5cqlp">
          {designs.map((design, index) => <Reveal key={design.slug} delay={index % 2 * 0.05} className="h-full" data-id="element-212" data-mp="3p6qnaf1c4lpu" data-mpi={index}>
              <DesignCard design={design} data-id="element-213" data-mp="3kbutpagg9qam" />
            </Reveal>)}
        </div>

        <div className="mt-12 flex flex-col items-center gap-4 text-center" data-id="element-214" data-mp="1xlot0eh7jnr">
          <Link to="/home-designs" className={buttonClass("primary")} data-id="element-215" data-mp="3t9n9efq32zyj">
            Compare all designs <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-216" data-mp="bt5fn8e6ns5n" />
          </Link>
          <p className="text-[16px] text-slate" data-id="element-217" data-mp="6vn4rcglv2v0">
            Not sure a design suits your block?{" "}
            <Link to="/contact?project=unsure" className="font-medium text-charcoal underline underline-offset-4" data-id="element-218" data-mp="kv6bq1xok85q">Talk to us about it.</Link>
          </p>
        </div>
      </div>
    </section>;
}